webpackJsonp([10],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(766),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    signUpButton: function signUpButton() {
      this.$router.push({ name: 'Signup' });
    },
    signInButton: function signInButton() {
      this.$router.push({ name: 'Signin' });
    }
  }
});

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logoPonce.e1379bf.png";

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "home without-padding",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "medium-div without-padding"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": __webpack_require__(738)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "div-register-button"
  }, [_c('v-btn', {
    staticClass: "register-button",
    on: {
      "click": _vm.signUpButton
    }
  }, [_vm._v("Registrate con tu correo")])], 1), _vm._v(" "), _c('p', {
    staticClass: "sign-in-text"
  }, [_vm._v("Ya tenes tu cuenta? "), _c('a', {
    staticClass: "sign-in-text",
    on: {
      "click": _vm.signInButton
    }
  }, [_c('u', [_vm._v("Ingresa")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.c3a865e1fd9698e67dfb.js